import { render, staticRenderFns } from "./ChatGPTActionDetailApi.vue?vue&type=template&id=1770c246&"
import script from "./ChatGPTActionDetailApi.vue?vue&type=script&lang=js&"
export * from "./ChatGPTActionDetailApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports